module.exports = __WEBPACK_EXTERNAL_MODULE_413__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 413
// module chunks = 0